<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <form v-on:submit="createWorkflow">
              <div class="col-md-5">
                <h5>Which Device?</h5>
                <br>
                <div class="list-group">
                  <router-link :to="'/admin/device/create/' + element.url" class="list-group-item device" v-for="element in devices">
                    <div class="d-flex w-100 justify-content-between">
                      <p style="font-size:25px">{{element.name}}</p>
                    </div>
                    <small>{{element.description}}</small>
                  </router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import FormTextArea from '../../elements/Form/FormTextArea'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'createdevice',
  components:{
    'form-text':FormText,
    'form-textarea':FormTextArea
  },
  data () {
    return {
      devices:[
        {name:"Mobile Device",description:"Mobile device to complete workflows.",url:"mobiledevice"}, 
        {name:"Location Tag",description:"Tags attached to a location for workflows.",url:"locationtag"},
        {name:"Intercom",description:"Intercom which plays and records Wire messages",url:"intercom"}
      ],
      selectedDevice: {}
    }
  },
  methods: {
    createWorkflow:function(){

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.device p{
  color: #000
}
.device small{
  color: #000
}
.device:hover {
    z-index: 2;
    color: #fff;
    background-color: #46B3E4;
    border-color: #46B3E4;
}
.device:hover p {
  color: #fff
}
.device:hover small {
  color: #fff
}
</style>



// WEBPACK FOOTER //
// CreateDevice.vue?7815fd52